import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import TextStyle = PIXI.TextStyle;
import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { Button } from '../UI/elements/buttons/Button';
import { PopUpName } from '../core/managers/PopUpManager';
import {
    createButton,
    createSprite,
    resizeTextByReference, showAdCanceled,
    showSorryNoAd, translate
} from '../utils/GameEngine';
import { TextStyles } from '../utils/TextStyles';
import { WinPopUpParams } from './winPopUp/WinPopUp';
import { AdButton } from '../UI/elements/buttons/AdButton';
import { CoreController } from '../core/CoreController';
import { GDAdManager } from '../core/managers/gameDistribution/GDAdManager';
import { GDManager } from '../core/managers/gameDistribution/GDManager';

export interface LosePopUpParams extends AbstractPopUpParams {
    retryFunction: () => void;
    continueFunction: () => void;
    levelIndex: number;
    rewardInCoins: number;
    showContinue: boolean;
}

export class LosePopUp extends AbstractPopUp {
    private retryFunction: () => void;
    private continueFunction: () => void;
    protected continueButton: Button;
    protected doubleButton: AdButton;
    private coinsScore: Text;

    constructor(public readonly name: PopUpName, params: LosePopUpParams) {
        super(name, params);
        this.retryFunction = params.retryFunction;
        this.continueFunction = params.continueFunction;
    }

    protected addFirstText(topOffset: number): void {
        const style: TextStyle = TextStyles.uiText.clone();
        style.fill = '0xa62732';
        style.wordWrapWidth = this.textBox.width - 16;
        this.text = new PIXI.Text(this.params.text, style);
        this.text.anchor.set(0.5, 0.5);
        resizeTextByReference(this.text, this.textBox, 0);
        this.text.position.set(
            this.textBox.x + this.textBox.width / 2,
            this.textBox.y + topOffset * 3
        );
        this.background.addChild(this.text);
    }

    protected addSecondText(topOffset: number): void {
        const style: TextStyle = TextStyles.winPopupText.clone();
        style.wordWrapWidth = this.textBox.width - 16;
        style.wordWrap = true;
        this.text2 = new PIXI.Text(this.params.text2, style);
        this.text2.anchor.set(0.5, 0.5);
        let textY: number = this.textBox.y + this.textBox.height / 2;
        if (this.text) {
            textY = this.text.y + this.text.height / 2 + this.text2.height / 2 + topOffset * 2;
        }
        this.text2.position.set(
            this.textBox.x + this.textBox.width / 2,
            textY
        );
        this.background.addChild(this.text2);

        const coinsText: Text = new Text(translate('coins') + ': ' + (this.params as LosePopUpParams).rewardInCoins, TextStyles.winPopupText);
        coinsText.anchor.set(0.5, 0.5);
        coinsText.position.set(
            this.textBox.x + this.textBox.width / 2,
            this.text2.y + 40
        );
        this.background.addChild(coinsText);

        const coinsSprite: Sprite = createSprite('popup_coins_icon', this);
        coinsSprite.anchor.set(0, 0.5);
        coinsSprite.position.set(coinsText.x + coinsText.width / 2 + 12, coinsText.y);
    }

    protected drawLayout(params?: any): void {
        super.drawLayout(params);
        this.image.scale.set(0.7, 0.7);
        this.background.cacheAsBitmap = false;
        this.addTitle();
        this.background.cacheAsBitmap = true;
        this.addContinueButton();
        this.addRetryButton();
    }

    private addTitle(): void {
        const titleBG: Sprite = createSprite('popup_level_bg', this.background);
        titleBG.anchor.set(0.5, 0.5);
        titleBG.position.set(this.imageBox.x + this.imageBox.width / 2, titleBG.height / 2);
        const levelText: Text = new Text(translate('level'), TextStyles.smallTextWhite);
        levelText.anchor.set(0.5, 0.5);
        levelText.position.set(titleBG.x, titleBG.y - titleBG.height / 2 + 16);
        this.background.addChild(levelText);
        const levelNumberText: Text = new Text('' + (this.params as LosePopUpParams).levelIndex, TextStyles.counterText);
        levelNumberText.anchor.set(0.5, 0.5);
        levelNumberText.position.set(titleBG.x, titleBG.y);
        this.background.addChild(levelNumberText);
    }

    private addContinueButton(): void {
        if (!CoreController.getInstance().isFB()) {
            // @ts-ignore
            if (!GDManager.getInstance().isAdSDKReady()) {
                return;
            }
        }
        this.doubleButton = new AdButton(this.onContinue.bind(this), translate('Continue\nplaying', true));
        this.addChild(this.doubleButton);
        this.doubleButton.position.set(183, this.buttonY);
    }

    private onContinue(): void {
        this.continueFunction();
    }

    public onAdExpired(): void {
        this.doubleButton.visible = false;
        this.addRetryButton();
    }

    public onAdFail(error: any): void {
        this.onAdExpired();
        if (error && error.code !== 'USER_INPUT') {
            showSorryNoAd();
        } else {
            showAdCanceled();
        }
    }

    public onAdLoading(): void {
        // this.doubleButton.onLoading();
    }

    private addRetryButton(): void {
        this.continueButton = createButton(
            'green_btn_large@2x',
            this,
            (): void => {
                this.retryFunction();
            },
            translate('Retry', true),
            true,
            true,
            1
        );
        let buttonX: number = this.background.width / 2;
        if (this.doubleButton) {
            buttonX = 566;
        }
        this.continueButton.position.set(buttonX, this.buttonY);
    }

    protected onClose(): void {
        super.onClose();
        (this.params as WinPopUpParams).returnFunction();
    }

    public destroy(options?: any): void {
        if (this.doubleButton) {
            this.doubleButton.destroy();
        }
        super.destroy(options);
    }
}